import * as React from 'react';
import S from './Form.styles';
const FormRow = ({ children, ...props }) => {
    return React.createElement(S.Row, { ...props }, children);
};
export default FormRow;
